export default function () {
  const wrapper = document.querySelector('.wrapper');
  let wait = false;
  let lastVal = window.scrollY;
  let actualVal = window.scrollY;

  document.addEventListener('scroll', function() {
    if (window.innerWidth > 998) return;

    actualVal = window.scrollY;
    if (wait) return;

    if (actualVal >= 10) {
      wrapper.classList.add('header-min');
    } else {
      wrapper.classList.remove('header-min');
    }

    wait = true;

    setTimeout(function () {
      wait = false;

      if (lastVal !== actualVal) {
        if (actualVal >= 10) {
          wrapper.classList.add('header-min');
        } else {
          wrapper.classList.remove('header-min');
        }
      }
    }, 200);

    lastVal = actualVal;
  });
}
